import IdentificationError from './IdentificationError';
class INEFileSizeIsExceeded extends IdentificationError {
    constructor(section, options) {
        super(`INE ${section} file size exceeds 15mb`, options);
    }
}
export default INEFileSizeIsExceeded;
